import { axios } from "./axios";
export interface TextTemplate {
  id: string;
  body: string;
  category: string;
}

export interface TextTemplateQuery {
  category?: string;
}

/**
 * テキストテンプレートの一覧を得る
 */
export async function getTextTemplates(
  query: TextTemplateQuery = {}
): Promise<TextTemplate[]> {
  const params = new URLSearchParams();
  params.set("category", query.category || "");
  const response = await axios.get(
    `get_text_templates.php?${params.toString()}`
  );
  return response.data.data as TextTemplate[];
}

export interface SaveTextTemplateCommand {
  id: string;
  body: string;
  category: string;
}

/**
 * テキストテンプレートを保存する
 */
export async function saveTextTemplate(
  command: SaveTextTemplateCommand
): Promise<void> {
  const data = new FormData();
  data.append("id", command.id);
  data.append("body", command.body);
  data.append("category", command.category);
  await axios.post("save_text_template.php", data);
}

/**
 * テキストテンプレートを削除する
 */
export async function deleteTextTemplate(id: string): Promise<void> {
  const data = new FormData();
  data.append("id", id);
  await axios.post("delete_text_template.php", data);
}
